import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import './StripeSubsStyle.css';
import css from './StripeSubscriptions.module.css';
Date.prototype.addMonths = function(montsToAdd) {
  var date = new Date(this.valueOf());
  date.setMonth(date.getMonth() + montsToAdd);
  return date;
};
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

export default function SubscriptionCard(props) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const subscription = props.subscription;
  const payAmount = ` ${subscription.plan.amount / 100} ${subscription.plan.currency} / ${
    subscription.plan.interval
  }`;
  const status = subscription.status;

  const currentPeriodEnd = new Date(subscription.current_period_end * 1000).toLocaleDateString();
  const currentPeriodStart = new Date(
    subscription.current_period_start * 1000
  ).toLocaleDateString();

  const momentOfCancel = new Date(subscription.canceled_at * 1000).toString();
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const cancelled = subscription.status === 'canceled';
  // const minRentingMonths = subscription.metadata.minRentingMonths
  //   ? subscription.metadata.minRentingMonths
  //   : 0;
  // const minRentingMonths = 2;
  // const monthsLimitInMiliseconds = minRentingMonths * 30 * 24 * 60 * 60 * 1000;
  // const subStartDate = new Date(subscription.start_date * 1000).getTime();
  // const today = new Date().getTime();
  // const cancelAvailable = today > subStartDate + monthsLimitInMiliseconds;
  // if (subscription.status !== 'canceled') {
  //   console.log(cancelAvailable);
  // }

  const listingName = subscription.metadata.listingTitle;
  const subscriptionStart = Number(subscription.metadata.subscriptionStart);
  const twoMonthsAheadOfSubsStart = new Date(subscriptionStart).addMonths(2);
  const now = new Date();
  const cancellationAvailable = now > twoMonthsAheadOfSubsStart;
  const firstAvDayForCancel = new Date(twoMonthsAheadOfSubsStart).toLocaleDateString();
  const subscriptionNotStartedYet =
    subscription.current_period_end &&
    subscription.trial_end &&
    subscription.current_period_end === subscription.trial_end;
  return (
    <Card className={classes.root}>
      <CardHeader
        // avatar={
        //   <Avatar aria-label="recipe" className={classes.avatar}>
        //     R
        //   </Avatar>
        // }
        action={
          <div className={css.actionsWrapper}>
            <span>{`État: ${status}`}</span>
            <a href={`/l/${listingName.replace(' ', '-')}/${subscription.metadata.listingId}`}>
              {listingName}
            </a>
          </div>
        }
        title={payAmount}
        // subheader="September 14, 2016"
      />
      {/* <CardMedia
        className={classes.media}
        image="/static/images/cards/paella.jpg"
        title="Paella dish"
      /> */}
      <CardActions disableSpacing>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <div className={css.expandedInfo}>
            {cancelled ? (
              <span>{`Annulé à: ${momentOfCancel}`}</span>
            ) : (
              <>
                {subscriptionNotStartedYet ? (
                  <span>{`L'abonnement commencera sur: ${currentPeriodEnd}`}</span>
                ) : (
                  <span>{`Fin de la période en cours: ${currentPeriodEnd}`}</span>
                )}
                {cancellationAvailable ? (
                  <Link
                    className={css.cancelText}
                    to={{
                      pathname: '/cancel',
                      state: { subscription: subscription, priceId: subscription.plan.id },
                    }}
                  >
                    Annuler
                  </Link>
                ) : (
                  <p
                    className={css.cancelText}
                  >{`*Vous pourrez résilier cet abonnement à partir de ${firstAvDayForCancel} en raison de la politique d'annulation de cette annonce`}</p>
                )}
              </>
            )}
          </div>
        </CardContent>
      </Collapse>
    </Card>
  );
}
